import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

export interface UserInfo {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  jobTitle: string;
}

const userApi = generateNomenApi<UserInfo>(`/users`); // TODO SEPARATE user from nomen

export const userOptions = generateNomenOptions('user', userApi);
